<template>
    <v-card class="ma-0 mb-6 pa-3" :border="true" flat v-if="!isFormReadOnly">
        <geometry-file-input v-model="geometryData" :accepting='["LineString", "MultiLineString"]' @update:model-value="geometryUpdated" />
    </v-card>



    <div>
        <p class="text-headline-small mt-3">Note</p>
        <v-textarea label="" v-model="properties.note"></v-textarea>
    </div>

    <div class="mb-5">
    <p class="text-headline-small">Data</p>

    <date-time-input 
    v-model="properties.timestamp" 
    />
  </div>

</template>

<script setup>

import { ref, computed, onMounted, inject } from "vue";
import { LineString } from 'ol/geom.js';
import * as olExtent from 'ol/extent';


import DateTimeInput from '@/reports/components/DateTimeInput.vue'
import GeometryFileInput from "@/reports/components/GeometryFileInput"

import { useDataStore } from "@/store/data";


const isFormReadOnly = ref(false)

const svf = inject(Symbol.for("vuetify:form"), { isReadonly: false })
isFormReadOnly.value = svf.isReadonly.value

const emit = defineEmits(["newGometry"])


const dataStore = useDataStore();

const properties = defineModel()




/*   dati base
uuid
traccia
timestamp
real_timestamp
segnalatore
model_name
created_timestamp
traccia_timestamp
traccia_timestamp_raw
the_geom_calculated
note

 */


const geometryData = ref({
    geometry: null,         // geometry
    // completeGeoJSON: null,         // complete geometry
    meta: null              // extracted metadata
})

const geometryUpdated = (() => {
    console.log("geometryUpdated")
    console.log(geometryData.value)
    console.log(properties.value)

    // data is the object in the store
    const data = dataStore.getDataFromFeatureUUID(properties.value.uuid)
    console.log(data)

    // old feature geometry
    const featureGeometry = data.feature.geometry

    if (geometryData.value.geometry) {

        const newGeometry = geometryData.value?.geometry
        const meta = geometryData.value?.meta

        if (!newGeometry) {
            console.log("no geometry found")
            return
        }

        if (newGeometry.type === "LineString") {

            data.feature.geometry = newGeometry

            const OLgeometry = new LineString(newGeometry.coordinates);
            // calcolo centro e lo assegno a lon - lat
            const gExt = OLgeometry.getExtent()
            const midPoint = olExtent.getCenter(gExt)
            properties.value.lon = midPoint[0]
            properties.value.lat = midPoint[1]
        }



    }


    dataStore.save()

})






</script>
